import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetCONUSDesktopByOrderId(orderId) {
  const response = await $.soap({
    body: {
      GetOFCONUSDesktopByOrderId: {
        $xmlns: 'http://dla.mil/ems/bpm/order/order_form',
        OrderId: orderId
      }
    },
    blueprint: {
      order: {
        orderId: '$..OrderID',
        customerSignature: '$..CustomerSignature',
        totalPrinterQuantity: '$..TotalPrinterQuantity',
        totalPrinterPrice: '$..TotalPrinterPrice',
        totalTonerQuantity: '$..TotalTonerQuantity',
        totalTonerPrice: '$..TotalTonerPrice',
        totalScannerQuantity: '$..TotalScannerQuantity',
        totalScannerPrice: '$..TotalScannerPrice',
        totalOrderQuantity: '$..TotalOrderQuantity',
        totalOrderPrice: '$..TotalOrderPrice',
        createdOn: '$..CreatedOn',
        createdBy: '$..CreatedBy',
        updatedOn: '$..UpdatedOn',
        updatedBy: '$..UpdatedBy',
        dateEquipmentReq: '$..DateEquipmentReq'
      }
    }
  });

  cleanUpResponse(response);
  return response.order;
}
